export default {
  title: 'Koszyk',
  buttons: {
    login_to_checkout: 'Zaloguj się, aby zamówić',
    checkout: 'Zamów',
  },
  go_to_menu: 'Przejdź do menu',
  toasts: {
    cashback_points_removed: 'Saldo Twoich punktów uległo zmianie, więc usunęliśmy punkty z tego zamówienia.',
  },
};
